import { render, staticRenderFns } from "./TeamQuestionSlide.vue?vue&type=template&id=629a927c&scoped=true"
import script from "./TeamQuestionSlide.vue?vue&type=script&lang=js"
export * from "./TeamQuestionSlide.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "629a927c",
  null
  
)

export default component.exports